export { default } from 'shared/components/context/box'
